import { connect } from 'react-redux'
import ModalActions from '../../../../../Redux/ModalRedux'
import PrintersFirmwareModal from './printers-firmware-modal'
import PrintersFirmwareModalSelector from './printers-firmware-modal.selector'
import { pipe } from 'ramda'
import { translate } from 'react-translate'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  translate('CardsModals'),
  connect(
    PrintersFirmwareModalSelector,
    mapDispatchToProps
  )
)(PrintersFirmwareModal)
